import { Graphics } from 'pixi.js';
import type { World, ComponentStore } from '@ecs/world';
import type { CameraResource, ExplosionComponent, TransformComponent } from '@game/scenes/characterPrototype/types';
import type { Tuning } from '@game/tuning';

export type ExplosionStyle = {
	fillColor: number;
	fillAlpha: number;
	strokeColor: number;
	strokeAlpha: number;
	strokeWidth: number;
};

export function createSpawnExplosion(style: ExplosionStyle) {
	return function spawnExplosion(
		world: World,
		transforms: ComponentStore<TransformComponent>,
		graphics: ComponentStore<Graphics>,
		stage: import('pixi.js').Application['stage'],
		x: number,
		y: number,
		tuning: Tuning
	) {
		const explosions = world.getResource<ComponentStore<ExplosionComponent>>('explosions-store');
		if (!explosions) return;
		const entity = world.createEntity();
		transforms.set(entity, { x, y });
		explosions.set(entity, {
			elapsed: 0,
			duration: tuning.explosionDuration,
			startRadius: 0.04,
			endRadius: tuning.explosionRadius
		});
		const camera = world.getResource<CameraResource>('camera');
		const offsetY = camera ? camera.y : 0;
		const g = new Graphics();
		g.circle(0, 0, 1);
		g.fill({ color: style.fillColor, alpha: style.fillAlpha });
		g.stroke({ color: style.strokeColor, alpha: style.strokeAlpha, width: style.strokeWidth });
		g.position.set(x, y - offsetY);
		stage.addChild(g);
		graphics.set(entity, g);
	};
}


